var _style, _path, _path2, _line, _line2, _line3, _line4, _line5, _path3, _path4, _path5, _g, _g2, _g3, _rect, _g4, _path6, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.7 72.4",
    style: {
      enableBackground: "new 0 0 61.7 72.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#14A800;}\r\n\t.st2{display:inline;fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{fill:#14A800;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132,18.1l12.2,10.7c0,0-6.7,2.4-10.6-0.3C129.7,25.8,132,18.1,132,18.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.4,17.3h-28.2c0,0-5.6,0.2-5.7,6.5v44.6c0,0-0.6,6.5,5.6,6.9h34.6c0,0,7-0.9,6.6-8.6v-37 c0,0-4.9,0.5-6.7,0.5c-2.1,0.1-6.4-1.3-6.7-6.1C130.8,21.6,131.4,17.3,131.4,17.3z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 105.246 46.4824)",
    style: {
      display: "inline",
      fontFamily: "'DejaVuSansMono-Bold'",
      fontSize: 18
    }
  }, "{:}"), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 97.5,
    y1: 59.4,
    x2: 143.7,
    y2: 59.2
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 108.8669 71.2064)",
    style: {
      display: "inline",
      fontFamily: "'DejaVuSansMono-Bold'",
      fontSize: 14
    }
  }, "css"), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 131.8,
    y1: 17,
    x2: 144.5,
    y2: 29.4
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 7.3,
    y1: 59.3,
    x2: 54.6,
    y2: 59.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 7.8,
    y1: 64.6,
    x2: 32,
    y2: 64.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 33.4,
    y1: 8.6,
    x2: 54.9,
    y2: 8.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.7,33.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.1,34.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.1,34.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 7.1,
    y1: 37.3,
    x2: 20.4,
    y2: 37.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 7.1,
    y1: 34.3,
    x2: 14.1,
    y2: 34.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.8,
    y: 22.4,
    className: "st3",
    width: 12.4,
    height: 8.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 24.1,
    y1: 37.3,
    x2: 37.4,
    y2: 37.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 24.1,
    y1: 34.3,
    x2: 31.2,
    y2: 34.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 22.4,
    className: "st3",
    width: 12.4,
    height: 8.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 41,
    y1: 37.3,
    x2: 54.3,
    y2: 37.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 41,
    y1: 34.3,
    x2: 48.1,
    y2: 34.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.8,
    y: 22.4,
    className: "st3",
    width: 12.4,
    height: 8.9
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.8,
    y: 42.6,
    className: "st4",
    width: 46.4,
    height: 11.7
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 9.6,
    cy: 8.8,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 16.3,
    cy: 8.8,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 22.8,
    cy: 8.8,
    r: 1.8
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.8,71.4h-54c-1.6,0-2.9-1.3-2.9-2.9V3.9C1,2.3,2.3,1,3.9,1h54c1.6,0,2.9,1.3,2.9,2.9v64.6 C60.7,70.1,59.4,71.4,57.8,71.4z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1.1,
    y1: 16.1,
    x2: 60.7,
    y2: 16.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.230eb1b7e52f3b0874fb1fad5a9e6c90.svg";
export { ForwardRef as ReactComponent };